import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  makeStyles,
} from '@material-ui/core';
import { OptionsFeedback } from './OptionsFeedback';
import type { AsyncOptions } from './useAsyncOptions';

const useStyles = makeStyles(theme => ({
  field: { marginBottom: theme.spacing(2) },
}));
interface RepoOptionSelectProps<T> {
  id: string;
  label: string;
  query: AsyncOptions<T>;
  value: string;
  optionId: (item: T) => string;
  optionLabel: (item: T) => string;
  onSelect: (item: T | null) => void;
  disabled?: boolean;
  hidden?: boolean;
}

export function RepoOptionSelect<T>({
  id,
  label,
  query,
  value,
  optionId,
  optionLabel,
  onSelect,
  disabled,
  hidden,
}: RepoOptionSelectProps<T>) {
  const classes = useStyles();
  return (
    <div className={classes.field}>
      {!hidden && (
        <FormControl
          variant="outlined"
          size="small"
          fullWidth
          disabled={disabled || query.status !== 'success'}
        >
          <InputLabel id={`${id}-label`}>{label}</InputLabel>
          <Select
            labelId={`${id}-label`}
            label={label}
            data-testid={`${id}-select`}
            value={
              query.items.some(item => optionId(item) === value) ? value : ''
            }
            onChange={event =>
              onSelect(
                query.items.find(
                  item => optionId(item) === event.target.value,
                ) ?? null,
              )
            }
          >
            {query.items.map(item => (
              <MenuItem key={optionId(item)} value={optionId(item)}>
                {optionLabel(item)}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}
      <OptionsFeedback query={query} label={label} />
    </div>
  );
}
